import { createSelector } from 'reselect';

const getSceneLinks = (state) => state.sceneConfiguration.links;

const getLinks = createSelector([getSceneLinks], (links) => links);

export default getLinks;
